import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class PolicyholderRegistrationService {

    static registerAndEnroll(PolicyholderRegistrationDTO, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policyholderRegistration'),
            'registerAndEnroll',
            [PolicyholderRegistrationDTO],
            additionalHeaders
        );
    }

}
